import { effectScope, watch } from 'vue'
import { pickProfileToSync } from './learnerProfile.js'

// 登录后把本地档案同步到账号。watcher 放在独立的 effectScope 里，
// 不跟随首次调用它的组件一起销毁（素材库、分类页、档案页之间切换时组件会被卸载）
export function startProfileSync({ ready, getLocal, getRemote, upload }) {
  const scope = effectScope(true)
  scope.run(() => {
    watch(ready, isReady => {
      if (!isReady) return
      const toSync = pickProfileToSync(getLocal(), getRemote())
      if (toSync) upload(toSync)
    }, { immediate: true })
  })
  return scope
}
